// extracted by mini-css-extract-plugin
export var contentWrapper = "cob-module--content-wrapper--yQ218";